import { useRecoilCallback } from 'recoil';
import { clearAnnotations } from '~/state/atoms/annotationListAtoms';
import {
    circleRegionDraftState,
    circleRegionListState,
    draggingLineProfileState,
    highlightedCircleRegionState,
    highlightedLineProfileState,
    lineProfileDraftState,
    lineProfileListState,
    selectedIntensityAnnotationState,
} from '~/state/atoms/intensityToolAtoms';

/**
 * Removes every line and circle the intensity tool has placed, with their
 * figures. Called when the patient is unloaded or the session ends, so
 * nothing read from one patient's image is ever shown over another's.
 * The measurement tool has the same in {@link useResetMeasurements}.
 */
export function useResetIntensityAnnotations(): () => void {
    return useRecoilCallback(
        (callback) => () => {
            clearAnnotations(callback, lineProfileListState);
            clearAnnotations(callback, circleRegionListState);
            for (const state of [
                lineProfileDraftState,
                selectedIntensityAnnotationState,
                highlightedLineProfileState,
                draggingLineProfileState,
                circleRegionDraftState,
                highlightedCircleRegionState,
            ]) {
                callback.reset(state);
            }
        },
        []
    );
}
